import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

// Renders a scannable Code128 barcode (self-contained, no network).
const Barcode = ({ value, format = 'CODE128', height = 44, width = 1.6, fontSize = 12, displayValue = true, margin = 6 }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      try {
        JsBarcode(ref.current, String(value), { format, height, width, fontSize, margin, displayValue });
      } catch (e) { /* invalid value — ignore */ }
    }
  }, [value, format, height, width, fontSize, displayValue, margin]);
  return <svg ref={ref} />;
};

export default Barcode;
